import { render, staticRenderFns } from "./MajorityActions.vue?vue&type=template&id=c8bf3e26&"
import script from "./MajorityActions.vue?vue&type=script&lang=js&"
export * from "./MajorityActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports